import React from 'react';
import Helmet from "react-helmet";
import {withRouter, RouteComponentProps} from 'react-router';

// model
import Data from '../../model/Data';
// Local components
import Header from './components/Header/Header';
import Description from './components/Description/Description';
import History from './components/History/History';
import Info from './components/Info/Info';
import Footer from './components/Footer/Footer';
//styles
import './About.css';
import './About320.css';
import './About768.css';
import './About1024.css';
import './About1280.css';
import './About1376.css';
import './About1920.css';
// helpers
import ResizeHelper from '../../common/helpers/resize';
import setCustomVw from '../../common/helpers/custom-vw';
import useYandexRotor from "../../common/helpers/useYandexRotor";


interface MatchParams {
  id: string;
  city: string;
}

type Props = RouteComponentProps<MatchParams>;

class About extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
    ResizeHelper.Instance.addCallback(this.refresh.bind(this));
  }

  componentDidMount() {
    setCustomVw();
  }

  refresh(): void {
    this.setState((prevState) => ({...prevState}));
  }

  render(): JSX.Element {
      useYandexRotor(Data.Instance.isDataLoaded);

    return (
      <div className="about">
        <Helmet
          title="О нас"
          key={`about-head`}
        />
        <Header/>
        <Description/>
        <History/>
        <Info/>
        <Footer/>
      </div>
    );
  }
}

export default withRouter(About);
